export function HarriSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/harri.svg'"></ng-include>`
    }
}